document.addEventListener('DOMContentLoaded', function() {
  const metalOptions = document.querySelectorAll('.swatch-container input');
  metalOptions.forEach(function(option) {
    option.addEventListener('click', function() {
      let optionContainer = option.closest('.grid__item');
      if (!optionContainer) {
        optionContainer = option.closest('div.swiper-slide');
      }
      const varScript = optionContainer.querySelector('script[type="application/json"]');
      const varData = JSON.parse(varScript.innerHTML);
      const selectedMetalOption = option;
      const selectedOptionValue = selectedMetalOption.value;
      const matchingVariant = varData.find(variant => variant.options.includes(selectedOptionValue));
      if (!matchingVariant) {
        console.error('Matching variant not found.');
        return;
      }
      const varImg = matchingVariant.featured_image.src;
      const mobileImg = varImg.replace(/(\.jpg|\.png)(\?.*)?$/, '_260x360_crop_center$1$2');
      const cardWrapper = option.closest('div.card-wrapper');
      if (!cardWrapper) {
        console.error('Card wrapper not found.');
        return;
      }
      const cardImgDesktop = cardWrapper.querySelector('div.card__inner div.media img');
      const cardImgMobile = cardWrapper.querySelector('div.card__inner div.mobile-swiper img');
      if (cardImgDesktop) {
        cardImgDesktop.src = `${varImg}?${new Date().getTime()}`;
        cardImgDesktop.srcset = `${varImg}?${new Date().getTime()}`;
      } else {
        console.error('Desktop image element not found.');
      }
      if (cardImgMobile) {
        cardImgMobile.src = `${mobileImg}?${new Date().getTime()}`;
        cardImgMobile.srcset = `${mobileImg}?${new Date().getTime()}`;
      } else {
        console.error('Mobile image element not found.');
      }
      const varPrice = matchingVariant.price;
      const formattedPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(varPrice / 100);
      const priceContainer = optionContainer.querySelector('span.price-item.price-item--regular');
      if (priceContainer) {
        priceContainer.textContent = formattedPrice;
      } else {
        console.error('Price container not found.');
      }
    });
  });

  const shopNowBtns = document.querySelectorAll('.shop__now button');
  shopNowBtns.forEach(function(btn) {
    btn.addEventListener('click', function(event) {
      event.preventDefault();
      if(!!btn.getAttribute('data-product-handle')) {
        window.location.href = '/products/' + btn.getAttribute('data-product-handle');
        return;
      }
      const optionContainer = btn.closest('.grid__item');
      const varScript = optionContainer.querySelector('script[type="application/json"]');
      const varData = JSON.parse(varScript.innerHTML);
      const optionType = btn.getAttribute('data-product-option-1');
      const selectedMetalOption = optionContainer.querySelector('.swatch-container input:checked');
      const optionElements = createRelatedOptionElements(varData, selectedMetalOption, optionType);
      if (window.matchMedia("(max-width: 768px)").matches) {
        // Create the overlay element
        const overlay = document.createElement('div');
        overlay.className = 'overlay';
        document.body.appendChild(overlay);
      
        // Append the option elements to the overlay
        overlay.appendChild(optionElements);
      
        // Create the close button
        const closeBtn = document.createElement('button');
        closeBtn.textContent = 'Close';
        closeBtn.className = 'close-options badge';
        closeBtn.addEventListener('click', function() {
          optionElements.remove();
          overlay.remove();
        });
      
        // Append the close button to the option elements
        optionElements.appendChild(closeBtn);
      } else {
        const productCard = btn.closest('.grid__item').querySelector('.card--product');
        productCard.appendChild(optionElements);
      }
    });
  });
});

function createRelatedOptionElements(variantData, optionName, optionType) {
  const matchingVariants = variantData.filter(variant => variant.options[0] === optionName.value);
  if (matchingVariants.length === 1) {
    const varId = Number(optionName.getAttribute('data-variant-id'));
    quickShopATC(event, varId);
    optionElements.remove();
  }
  const optionCount = Math.max(...matchingVariants.map(v => v.options.length)) - 1;
  const container = document.createElement('div');
  container.className = 'options-container active slide-in-bottom';
  const optionGroups = Array.from({ length: optionCount }, (_, pos) => {
    pos += 1; 
    const optionGroup = document.createElement('div');
    optionGroup.className = `option-group option-group-${pos}`;
    const uniqueOptions = [...new Set(matchingVariants.map(v => v.options[pos]).filter(Boolean))];
    const heading = document.createElement('h3');
    heading.textContent = `Select ${optionType}`;
    container.appendChild(heading);
    uniqueOptions.forEach((option, index) => {
      const matchingVariant = matchingVariants.find(v => v.options[pos] === option);
      const sku = matchingVariant.sku;
      const variantId = matchingVariant.id;
      const productTitle = matchingVariant.name.split(' - ')[0];
      const wrapper = document.createElement('div');
      wrapper.className = 'option-wrapper';
      const input = document.createElement('input');
      input.type = 'radio';
      input.id = `option-${sku}-${pos}-${index}`;
      input.name = `${productTitle}`;
      input.value = option;
      input.dataset.variantId = variantId;
      input.dataset.variantAvailable = matchingVariant.available;
      const label = document.createElement('label');
      label.htmlFor = `option-${sku}-${pos}-${index}`;
      label.textContent = option;
      if(matchingVariant.available === false) {
        input.disabled = true;
        input.setAttribute('aria-disabled', true);
        label.classList.add('disabled');
      }
      input.addEventListener('change', quickShopATC);
      wrapper.append(input, label);
      optionGroup.appendChild(wrapper);
    });
    return optionGroup;
  });
  
  async function quickShopATC(event, varId = null){
    event.preventDefault();
    const quickShopOrigin = window.location.pathname;
    let quickShopCollection = null;
    let quickShopSearch = null;
    if (quickShopOrigin.includes('/collections')) { 
      quickShopCollection = 'Collection: ' + window.location.pathname.split('/collections/')[1];
    } else if (quickShopOrigin.includes('/search')) {
      const searchQuery = window.location.search.split('=')[1].split('&')[0];
      quickShopSearch = 'Search: ' + decodeURIComponent(searchQuery).replace(/\+/g, ' ');
    }
    if(varId === null) {
      varId = Number(event.srcElement.getAttribute('data-variant-id'))
    }
    let quickShopSend = {
      items: [{
        id: varId,
        quantity: 1,
        'properties': {
          '_quick_shop': `${quickShopCollection || quickShopSearch}`
        } 
      }],
      sections: cartSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };
    let response = await fetch(`/cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(quickShopSend)
    })
    if(!response.ok) {
      throw new Error(`Something is up! Status: ${response.status}`);
    }
    else {
      if (window.matchMedia("(max-width: 768px)").matches) {
        const mobileOptionsContainer = document.querySelector('.options-container.active');
        const optionsBtn = document.querySelector('.options-container button.close-options');
        if(!!optionsBtn) {
          mobileOptionsContainer.remove();
        }
      }
      updateShippingThreshold();
      window.scrollTo(0, 0);
      const cartNotification = document.getElementById('cart-notification');
      cartNotification.focus();
      cartNotification.classList.add('active');
      let notEmptyCart = document.getElementById('shopify-section-mini-cart');
      notEmptyCart.querySelector('.mini-cart-container').classList.add('not-empty');
      const parsedState = await response.json();
      await updateCartSections(parsedState);
    }
  }

  async function updateCartSections(parsedState) {
    cartSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id) ? document.getElementById(section.id).querySelector(section.selector) : null;
      if (elementToReplace) {
        const innerHTMLValue = findCollectionSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (innerHTMLValue) {
            elementToReplace.innerHTML = innerHTMLValue;
        } else {
            console.warn(`No innerHTML value found for selector ${section.selector}`);
        }
      } else {
        console.warn(`Element not found for id: ${section.id}`);
      }
    })
    updateCartHeaderFooter();
  }

  function findCollectionSectionInnerHTML(html, selector) {
    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedDocument.querySelector(selector);
    if (!element) {
      console.error(`Element not found for selector: ${selector}`);
      return null;
    }
    return element.innerHTML;
  }
  
  function cartSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }
  
  container.append(...optionGroups);

  return container;
}
